export default __webpack_public_path__ + "static/Corporate_Responsibility_ReponsibleSourcing_07-2d54b0a1f9da6775c9d3457f94e39c97.jpg";